import { Model, Request } from '@viddsee/server-api-client';

import { channel as channelIds, channelEdition as channelEditionIds, channelEditionPlaylist as channelEditionPlaylistIds } from '@/scripts/models/videoCollections/identifierDefinitions/channel';
import { ChannelCollectionImplementation } from '@/scripts/models/videoCollections/implementations/ChannelCollectionImplementation';
import { CollectionImplementationData } from './videoCollections/implementations/core/BaseCollectionImplementation';
import { VideoRelatedEndpoint, VideoRelatedEndpointInfoPayload } from './VideoRelatedEndpoint';
import urlLocationHelper from '../helpers/url-location-helper';

export class ChannelVideoRelatedEndpoint extends VideoRelatedEndpoint {
  implementationData: CollectionImplementationData;

  constructor(videoRelatedEndpoint: Model.Video.RelatedVideoEndpoint) {
    super(videoRelatedEndpoint);

    const [
      /* blankSpace */,
      /* channelId */,
      channelSlug,
      /* editionId */,
      editionSlug,
      /* playlistId */,
      playlistSlug,
    ] = this.videosEndpoint.split('/');

    const params = [
      [channelIds.queryId, channelSlug],
      [channelEditionIds.queryId, editionSlug],
      [channelEditionPlaylistIds.queryId, playlistSlug],
    ]
      .reduce((acc, [id, value]) => {
        if (!value || !id) return acc;
        acc[id] = value;
        return acc;
      }, {} as Record<string, string>)
    ;

    this.implementationData = new ChannelCollectionImplementation({
      params,
    })
      .provide();

    const implementationData = this.implementationData;

    this.videoTransformer = {
      url(url): string {
        const videoCollectionVideoQueryString = urlLocationHelper.query.encode(
          implementationData.implementation.identifierValues.reduce((acc, { ids, value }) => ({
            ...acc,
            [ids.queryId]: value,
          }), {}),
        );

        return url + videoCollectionVideoQueryString;
      },
    };
  }

  async getVideos(params: Request.Pagination.Options = {}): Promise<Model.Pagination.PaginatedItemsResponse<Model.Video.Info> | null> {
    if (!(this.implementationData.fetchers && this.implementationData.fetchers.videos)) {
      return null;
    }
    const response = await this.implementationData.fetchers.videos(params);
    return response;
  }

  async getInfo(): Promise<VideoRelatedEndpointInfoPayload | null> {
    if (!(this.implementationData.fetchers && this.implementationData.fetchers.info)) {
      return null;
    }

    try {
      const info = await this.implementationData.fetchers.info();
      if (!info) {
        return null;
      }
      return ({
        author: this.implementationData.author,
        publicUrl: this.implementationData.publicUrl,
        info,
      });
    } catch (error) {
      // TODO: Use a centralized error logger
      // eslint-disable-next-line no-console
      console.error(error);
      return null;
    }
  }
}
